import { Injectable } from '@angular/core';
import { ShellDomainProvider } from '../utility/shell-domain.provider';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const header: any = new HttpHeaders({
    'Content-Type': 'application/json'
});


@Injectable()
export class SequenceNumberGeneratorService{

    constructor(private http:HttpClient){}

    generateSequenceNumber(context:string):Observable<any>{
        return this.http.get(ShellDomainProvider['api'].SequenceNumberService+`Next?Context=${context}`,
        {
            headers:header,
            withCredentials:true,
            observe:'response'
        });
    }

    resetSequenceNumber(context:string,value:number):Observable<any>{
        return this.http.post(ShellDomainProvider['api'].SequenceNumberService+`Reset?Context=${context}&Value=${value}`,
        {
            headers:header,
            withCredentials:true,
            observe:'response'
        });
    }


}